import { helpers } from '@vuelidate/validators';
export const passwordStrength = helpers.regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[!-\/:-@[-`{-~])(?=.*[0-9])(?=.{8,})/);
